import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledRadioGroup, Fieldset } from '@components';

export const EmploymentStatus = () => {
  const { t } = useTranslation('subModules/employmentStatus');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };

  const { setValue, trigger } = useFormContext();

  const handleEmploymentStatusChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValue = event.target.value;

    if (selectedValue === 'FULL_TIME') {
      setValue('incomeConsistency', 'VERY_CONSISTENT');
    } else {
      setValue('incomeConsistency', '');
    }

    trigger('employmentStatus');
  };

  return (
    <Fieldset label={t('label')} required>
      <ControlledRadioGroup
        name="employmentStatus"
        fields={fields}
        aria-labelledby="employment-status-radio-buttons"
        onChange={handleEmploymentStatusChange}
        data-testid="employmentStatusSubModule"
        data-tf-sensitive="true"
      />
    </Fieldset>
  );
};
